export default "__VITE_ASSET__f747133d__"